"use client"

import IconFont from "@repo/ui/iconfont"
import { useSigninModal } from "@repo/ui/signin"
import { useResponsive } from "ahooks"
import Tooltip from "antd/es/tooltip"
import { useTranslations } from "next-intl"

import Style from "./index.module.scss"

export default function LockIcon() {
	const { showSignInModal } = useSigninModal()
	const responsive = useResponsive()
	const t = useTranslations("PreciousMetalsPage")
	return (
		<Tooltip title={t("signInToView")}>
			<IconFont
				type="icon-suo"
				style={{ fontSize: 22 }}
				className={Style.lock}
				onClick={() => {
					showSignInModal({
						action: "login",
						animate: responsive.md ? "modal" : "drawer",
						onLoginSuccess: () => {
							window.location.reload()
						},
						onRegisterSuccess: () => {
							window.location.reload()
						},
					})
				}}
			/>
		</Tooltip>
	)
}
